import { CameraAlt, Description, Dvr, NotInterested, Videocam } from '@mui/icons-material'
import { Typography } from '@mui/material'

function FiletypeIcon({ id }: { id: number }) {
  const fileTypeValues = [
    <NotInterested fontSize="small" />,
    <Description fontSize="small" />,
    <CameraAlt fontSize="small" />,
    <Videocam fontSize="small" />,
    <Dvr fontSize="small" />
  ]

  return <Typography variant="caption">{fileTypeValues[id]}</Typography>
}

export default FiletypeIcon
